import { Route, Routes } from "react-router";
import {
  NoInvoiceMoneyTransferScreen,
  NoInvoiceMoneyTransferScreenPath,
} from "./MoneyTransfer/NoInvoiceMoneyTransferScreen.tsx";
import {
  DisplayMoneyTransferInfoScreen,
  DisplayMoneyTransferInfoScreenPath,
} from "./MoneyTransfer/DisplayMoneyTransferInfoScreen.tsx";
import {
  InvoiceMoneyTransferScreen,
  InvoiceMoneyTransferScreenPath,
} from "./MoneyTransfer/InvoiceMoneyTransferScreen.tsx";
import {
  HeyLightCheckoutScreen,
  HeyLightCheckoutScreenPath,
} from "./HeyLight/HeyLightCheckoutScreen.tsx";
import { ProtectedRoute } from "./Auth/ProtectedRoute.tsx";
import {
  AdminHeyLightAllOrdersScreen,
  AdminHeyLightAllOrdersScreenPath,
} from "./Admin/HeyLight/AdminHeyLightAllOrdersScreen.tsx";
import { LoginScreen, LoginScreenPath } from "./Auth/LoginScreen.tsx";
import { LogoutScreen, LogoutScreenPath } from "./Auth/LogoutScreen.tsx";
import {
  AdminHeyLightAllProductScreen,
  AdminHeyLightAllProductScreenPath,
} from "./Admin/Product/AdminHeyLightAllProductScreen.tsx";
import {
  CreateHeyLightProductScreen,
  CreateHeyLightProductScreenPath,
} from "./Admin/Product/CreateHeyLightProductScreen.tsx";
import { KnownAuth0Roles } from "./Auth/KnownAuth0Roles.ts";
import {
  AllHeyLightOrdersCloserScreen,
  AllHeyLightOrdersCloserScreenPath,
} from "./Closer/HeyLight/AllHeyLightOrdersCloserScreen.tsx";
import {
  NotHavePermissionToSeePageScreen,
  NotHavePermissionToSeePageScreenPath,
} from "./Auth/NotHavePermissionToSeePageScreen.tsx";
import {
  AdminAllNormasTeachingProductScreen,
  AdminAllNormasTeachingProductScreenPath,
} from "./Admin/NormasTeachingProduct/AdminAllNormasTeachingProductScreen.tsx";
import {
  AdminStripeAllOrdersScreen,
  AdminStripeAllOrdersScreenPath,
} from "./Admin/Stripe/AdminStripeAllOrdersScreen.tsx";
import {
  CreateNormasTeachingProductScreen,
  CreateNormasTeachingProductScreenPath,
} from "./Admin/NormasTeachingProduct/CreateNormasTeachingProductScreen.tsx";
import {
  AllStripeOrdersCloserScreen,
  AllStripeOrdersCloserScreenPath,
} from "./Closer/Stripe/AllStripeOrdersCloserScreen.tsx";
import {
  CreateNormasTeachingBundleScreen,
  CreateNormasTeachingBundleScreenPath,
} from "./Admin/NormasTeachingBundle/CreateNormasTeachingBundleScreen.tsx";
import {
  AdminAllNormasTeachingBundleScreen,
  AdminAllNormasTeachingBundleScreenPath,
} from "./Admin/NormasTeachingBundle/AdminAllNormasTeachingBundleScreen.tsx";
import {
  NormasTeachingCheckoutScreen,
  NormasTeachingCheckoutScreenPath,
} from "./NormasTeachingCheckout/NormasTeachingCheckoutScreen.tsx";
import {
  AdminAllNormasTeachingCouponScreen,
  AdminAllNormasTeachingCouponScreenPath,
} from "./Admin/NormasTeachingCoupon/AdminAllNormasTeachingCouponScreen.tsx";
import {
  CreateNormasTeachingCouponScreen,
  CreateNormasTeachingCouponScreenPath,
} from "./Admin/NormasTeachingCoupon/CreateNormasTeachingCouponScreen.tsx";
import {
  NormasTeachingCheckoutStripePaymentFailure,
  NormasTeachingCheckoutStripePaymentFailurePath,
} from "./NormasTeachingCheckout/CheckOutFailedPage.tsx";
import {
  EditNormasTeachingProductScreen,
  EditNormasTeachingProductScreenPath,
} from "./Admin/NormasTeachingProduct/EditNormasTeachingProductScreen.tsx";
import {
  EditNormasTeachingBundleScreen,
  EditNormasTeachingBundleScreenPath,
} from "./Admin/NormasTeachingBundle/EditNormasTeachingBundleScreen.tsx";
import {
  CardInstallmentsUpdatePaymentStep,
  NormasTeachingCheckoutStripeUpdatePaymentPath,
} from "./NormasTeachingCheckout/PaymentSteps/Card/CardInstallmentsUpdatePaymentStep.tsx";
import {
  StripeOrderDetailsScreen,
  StripeOrderDetailsScreenPath,
} from "./Admin/Stripe/StripeOrderDetailsScreen.tsx";
import {
  HeyLightOrderDetailsScreen,
  HeyLightOrderDetailsScreenPath,
} from "./Admin/HeyLight/HeyLightOrderDetailsScreen.tsx";
import {
  EditNormasTeachingCouponScreen,
  EditNormasTeachingCouponScreenPath,
} from "./Admin/NormasTeachingCoupon/EditNormasTeachingCouponScreen.tsx";
import {
  AdminAllPromosScreen,
  AdminAllPromosScreenPath,
  CreatePromoScreenPath,
} from "./Admin/NormasTeachingPromo/AdminAllPromosScreen.tsx";
import { CreatePromoScreen } from "./Admin/NormasTeachingPromo/CreatePromoScreen.tsx";
import { SalesStatisticsScreen } from "./Admin/SalesStatistics/SalesStatisticsScreen.tsx";
import { SalesStatisticsScreenPath } from "./Admin/SalesStatistics/salesStatisticsPath.ts";
import {
  EditPromoScreen,
  EditPromoScreenPath,
} from "./Admin/NormasTeachingPromo/EditPromoScreen.tsx";
import {
  AllBonificoOrdersScreen,
  AllBonificoOrdersScreenPath,
} from "./Admin/BonificoOrder/AllBonificoOrdersScreen.tsx";
import {
  AllWithdrawalRequestsScreen,
  AllWithdrawalRequestsScreenPath,
} from "./Admin/Withdrawal/AllWithdrawalRequestsScreen.tsx";
import {
  CreateBonificoOrderScreen,
  CreateBonificoOrderScreenPath,
} from "./Admin/BonificoOrder/CreateBonificoOrderScreen.tsx";
import {
  ConfirmBonificoDraftScreen,
  ConfirmBonificoDraftScreenPath,
} from "./Admin/BonificoOrder/ConfirmBonificoDraftScreen.tsx";
import {
  BonificoCheckoutScreen,
  BonificoCheckoutScreenPath,
} from "./BonificoCheckout/BonificoCheckoutScreen.tsx";
import {
  BonificoBankDetailsScreen,
  BonificoBankDetailsScreenPath,
} from "./BonificoCheckout/BonificoBankDetailsScreen.tsx";

function App() {
  return (
    <>
      <Routes>
        <Route
          path={NoInvoiceMoneyTransferScreenPath}
          element={<NoInvoiceMoneyTransferScreen />}
        />
        <Route
          path={InvoiceMoneyTransferScreenPath}
          element={<InvoiceMoneyTransferScreen />}
        />
        <Route
          path={DisplayMoneyTransferInfoScreenPath}
          element={<DisplayMoneyTransferInfoScreen />}
        />
        <Route
          path={HeyLightCheckoutScreenPath}
          element={<HeyLightCheckoutScreen />}
        />
        <Route
          path={NormasTeachingCheckoutScreenPath}
          element={<NormasTeachingCheckoutScreen />}
        />
        <Route
          path={NormasTeachingCheckoutStripeUpdatePaymentPath}
          element={<CardInstallmentsUpdatePaymentStep />}
        />
        <Route
          path={NormasTeachingCheckoutStripePaymentFailurePath}
          element={<NormasTeachingCheckoutStripePaymentFailure />}
        />
        <Route
          path={BonificoCheckoutScreenPath}
          element={<BonificoCheckoutScreen />}
        />
        <Route
          path={BonificoBankDetailsScreenPath}
          element={<BonificoBankDetailsScreen />}
        />
        <Route path={LoginScreenPath} element={<LoginScreen />} />
        <Route path={LogoutScreenPath} element={<LogoutScreen />} />
        <Route
          path={NotHavePermissionToSeePageScreenPath}
          element={<NotHavePermissionToSeePageScreen />}
        />
        <Route
          path={AdminHeyLightAllOrdersScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminHeyLightAllOrdersScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminHeyLightAllOrdersScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AdminStripeAllOrdersScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminStripeAllOrdersScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminStripeAllOrdersScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AdminHeyLightAllProductScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminHeyLightAllProductScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminHeyLightAllProductScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AdminAllNormasTeachingProductScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminAllNormasTeachingProductScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminAllNormasTeachingProductScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AdminAllNormasTeachingCouponScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminAllNormasTeachingCouponScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminAllNormasTeachingCouponScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AdminAllNormasTeachingBundleScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminAllNormasTeachingBundleScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminAllNormasTeachingBundleScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreateHeyLightProductScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreateHeyLightProductScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreateHeyLightProductScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreateNormasTeachingProductScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreateNormasTeachingProductScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreateNormasTeachingProductScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={EditNormasTeachingProductScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={EditNormasTeachingProductScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <EditNormasTeachingProductScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreateNormasTeachingBundleScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreateNormasTeachingBundleScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreateNormasTeachingBundleScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreateNormasTeachingCouponScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreateNormasTeachingCouponScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreateNormasTeachingCouponScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={EditNormasTeachingBundleScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={EditNormasTeachingBundleScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <EditNormasTeachingBundleScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AllHeyLightOrdersCloserScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Closer, KnownAuth0Roles.Admin]}
              path={AllHeyLightOrdersCloserScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AllHeyLightOrdersCloserScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AllStripeOrdersCloserScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Closer, KnownAuth0Roles.Admin]}
              path={AllStripeOrdersCloserScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AllStripeOrdersCloserScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={StripeOrderDetailsScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={StripeOrderDetailsScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <StripeOrderDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={HeyLightOrderDetailsScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={HeyLightOrderDetailsScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <HeyLightOrderDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={EditNormasTeachingCouponScreenPath}
          element={<EditNormasTeachingCouponScreen />}
        />
        <Route
          path={AdminAllPromosScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AdminAllPromosScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AdminAllPromosScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreatePromoScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreatePromoScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreatePromoScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={EditPromoScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={EditPromoScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <EditPromoScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={SalesStatisticsScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={SalesStatisticsScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <SalesStatisticsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AllBonificoOrdersScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AllBonificoOrdersScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AllBonificoOrdersScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={AllWithdrawalRequestsScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={AllWithdrawalRequestsScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <AllWithdrawalRequestsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={CreateBonificoOrderScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={CreateBonificoOrderScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <CreateBonificoOrderScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path={ConfirmBonificoDraftScreenPath}
          element={
            <ProtectedRoute
              requiredRoles={[KnownAuth0Roles.Admin]}
              path={ConfirmBonificoDraftScreenPath}
              redirectIfNotAuthenticatedUrl={LoginScreenPath}
            >
              <ConfirmBonificoDraftScreen />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
